module.exports = __webpack_public_path__ + "static/media/logo_wo_tagline_white_640x192.4641bce3.png";